import React from 'react';
import '../styles/HptScreens.css'; //IMPORTAMOS LA HOJA GLOBAL

const SignatureTracker = ({ pasos }) => {
    return (
        <div className="tracker-container">
            <h4 className="tracker-title">Estado de Validación Secuencial</h4>
            <div className="tracker-timeline">
                {pasos.map((paso, index) => (
                    <div key={paso.rol} className="tracker-step">
                        {/* Círculo de estado */}
                        <div className={`tracker-circle ${paso.firmado ? 'circle-signed' : 'circle-pending'}`}>
                            {paso.firmado ? '✓' : index + 1}
                        </div>
                        
                        {/* Información del paso */}
                        <div className="tracker-info">
                            <span className="tracker-role-label">{paso.etiqueta}</span>
                            {paso.firmado ? (
                                <div className="tracker-signed-data">
                                    <span className="tracker-user-name">👤 {paso.usuario}</span>
                                    <span className="tracker-date">📅 {paso.fecha}</span>
                                </div>
                            ) : (
                                <span className="tracker-pending-text">Pendiente de validación</span>
                            )}
                        </div>
                        
                        {/* Línea conectora entre pasos */}
                        {index !== pasos.length - 1 && <div className="tracker-line" />}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SignatureTracker;